import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { GiExpense } from "react-icons/gi";
import { MdOutlineMiscellaneousServices, MdSettingsPower } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { AiFillDashboard } from "react-icons/ai";
import { BsFolder, BsPlusCircle, BsListUl } from "react-icons/bs";
import { getUserRole } from "../roleCrypto";

const LOGO = process.env.REACT_APP_LOGO;

function Sidebar({ isOpen, toggleSidebar }) {


  const location = useLocation();

  const [caseOpen, setCaseOpen] = useState(false);
  const userRole = getUserRole();

  const menuItems = [
  { name: "Dashboard", path: "/dashboard", icon: <AiFillDashboard /> },
  { name: "Users", path: "/users", icon: <FaUsers /> },
  { name: "Services", path: "/services", icon: <MdOutlineMiscellaneousServices /> },

  ...(userRole !== "subadmin"
    ? [{ name: "Expense", path: "/expenses", icon: <GiExpense /> }]
    : []),
];

  // ✅ Auto open Case Files based on route
  useEffect(() => {
    if (location.pathname.startsWith("/case-files")) {
      setCaseOpen(true);
    }
  }, [location.pathname]);

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          onClick={toggleSidebar}
          className="fixed inset-0 bg-black/50 md:hidden z-40"
        />
      )}

      <aside
        className={`fixed md:static top-0 left-0 min-h-screen w-72 bg-gradient-to-b from-gray-900 via-gray-800 to-black text-white z-50 shadow-2xl transform transition-transform duration-300
        ${isOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"}`}
      >
        {/* LOGO */}
        <div className="p-5 border-b border-gray-700 flex items-center gap-3">
          <img
            src={LOGO}
            alt="logo"
            className="h-10 w-30 rounded object-cover"
          />
        </div>

        {/* MENU */}
        <nav className="p-5 space-y-2">
          {menuItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-xl transition
                ${
                  isActive
                    ? "bg-gradient-to-r from-purple-500 to-blue-500 text-white shadow-lg"
                    : "text-gray-300 hover:bg-gray-700"
                }`
              }
            >
              <span className="text-lg">{item.icon}</span>
              {item.name}
            </NavLink>
          ))}

          {/* CASE FILES DROPDOWN */}
          <div>
            <button
              onClick={() => setCaseOpen((prev) => !prev)}
              className="flex items-center gap-3 px-4 py-3 w-full text-gray-300 hover:bg-gray-700 rounded-xl transition"
            >
              <BsFolder />
              Case Files
              <span className="ml-auto">{caseOpen ? "▲" : "▼"}</span>
            </button>

            {caseOpen && (
              <div className="ml-6 mt-2 space-y-2">
                <NavLink
                  to="/case-files/create"
                  onClick={() => setCaseOpen(true)}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition
                    ${
                      isActive
                        ? "bg-purple-500 text-white"
                        : "text-gray-400 hover:bg-gray-700"
                    }`
                  }
                >
                  <BsPlusCircle />
                  Create File
                </NavLink>

                <NavLink
                  to="/case-files/list"
                  onClick={() => setCaseOpen(true)}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition
                    ${
                      isActive
                        ? "bg-purple-500 text-white"
                        : "text-gray-400 hover:bg-gray-700"
                    }`
                  }
                >
                  <BsListUl />
                  File List
                </NavLink>


                  <NavLink
                  to="/payment-slip"
                  onClick={() => setCaseOpen(true)}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition
                    ${
                      isActive
                        ? "bg-purple-500 text-white"
                        : "text-gray-400 hover:bg-gray-700"
                    }`
                  }
                >
                  <BsListUl />
                  Payment Slip
                </NavLink>
              </div>
            )}
          </div>

          {/* SETTINGS */}
            {userRole !== "subadmin" && (
              <NavLink
                to="/setting"
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-xl transition
                  ${
                    isActive
                      ? "bg-gradient-to-r from-purple-500 to-blue-500 text-white shadow-lg"
                      : "text-gray-300 hover:bg-gray-700"
                  }`
                }
              >
                <MdSettingsPower />
                Setting
              </NavLink>
            )}
        </nav>

      </aside>
    </>
  );
}

export default Sidebar;